<template>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4>
                <v-card class="elevation-12">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>Reset Password</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-form @submit.prevent="onReset()">
                            <password
                                    name="password"
                                    v-validate="'required|min:8'"
                                    :secureLength="8"
                                    placeholder='Please enter your new password. Minimum 8 characters'
                                    v-model="password"
                                    @score="showScore"
                                    @feedback="showFeedback"
                                    ref="password"
                            />
                            <v-text-field
                                    v-validate="'required|confirmed:password'"
                                    data-vv-as="password"
                                    ref="confirm"
                                    :error-messages="errors.collect('confirm')"
                                    prepend-icon="lock"
                                    label="Confirm Password"
                                    v-model="confirm"
                                    name="confirm"
                                    type="password">
                            </v-text-field>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn tabindex="2" :to="{ name: 'forgot'}" outline color="error">Forgot</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn tabindex="1" :disabled="!isFormValid" color="primary" @click="onReset()">Reset</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import Password from 'vue-password-strength-meter'
export default {
  name: 'Reset',
  components: { Password },
  data () {
    return {
      snackbar: false,
      message: null,
      snackbarColor: 'success',
      timeout: 10000,
      isSubmitting: false,
      password: null,
      confirm: null,
      token: null,
      suggestions: null,
      warnings: null
    }
  },
  created () {
    try {
      this.token = Object.keys(this.$route.query)[0]
    } catch (e) {
      this.token = null
    }
  },
  computed: {
    isFormValid () {
      return Object.keys(this.fields).every(key => this.fields[key].validated) && Object.keys(this.fields).every(key => this.fields[key].valid)
    }
  },
  methods: {
    onReset () {
      this.isSubmitting = true
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.axios.post('auth/reset', {
            password: this.password,
            confirm: this.confirm,
            token: this.token
          }).then((response) => {
            this.$snotify.success(response.data.data.success)
            this.$router.push({ name: 'login' })
          }).catch((error) => {
            this.$snotify.error(error.response.data.data.error)
          }).finally(() => {
            this.isSubmitting = false
          })
        }
      })
    },
    showFeedback ({ suggestions, warning }) {
      let messages = suggestions
      if (warning) {
        messages.push(warning)
      }
      if (messages.length > 0) {
        for (let m of messages) {
          this.$snotify.success(m)
        }
      }
    },
    showScore (score) {
    }
  }
}
</script>

<style scoped>

</style>
